'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value"],
  _excluded2 = ["value", "highValue"],
  _excluded3 = ["value", "highValue"];
import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as ListSegClassicAssetFamilies from './ListSegClassicAssetFamilies';
import * as OperationTypes from './OperationTypes';
import * as OperatorTypes from './ListSegClassicOperatorTypes';
import * as Operators from '../../filterQueryFormat/operator/Operators';
import { AdsEntityListTypes, PRIVACY_CONSENT, __ANY_CTA, __ANY_FORM, __ANY_LINK, __ANY_PAGE } from './ListSegConstants';
import { BranchKeyByAssetFamily, FilterLinesKeyByAssetFamily } from './fromListSegClassic';
import { DSAssetFamilyToListSegClassicType } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilyMappings';
import { Map as ImmutableMap } from 'immutable';
import { OperatorsToListType } from './ListSegUtils';
import { __ANY_WEBINAR } from './ListSegConstants';
import { convertSimpleDateToTimestamp } from '../../filterQueryFormat/timestamps/TimestampConverters';
import { testDynamicFilterFamily } from '../../filterQueryFormat/DynamicFilterFamilies';
import Constraint from '../../filterQueryFormat/logic/Constraint';
import curry from 'transmute/curry';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import identity from 'transmute/identity';
import invariant from 'react-utils/invariant';
import isNumber from 'transmute/isNumber';
import isString from 'transmute/isString';
import protocol from 'transmute/protocol';
const getEngagementValueField = (type, value) => {
  if (value === undefined || value === null) {
    return {};
  }
  switch (type) {
    case OperationTypes.STRING:
    case OperationTypes.ENUMERATION:
    case OperationTypes.NUMBER:
      return {
        strValue: value
      };
    case OperationTypes.INT:
    case OperationTypes.INTEGER:
      return {
        intValue: value
      };
    case OperationTypes.LONG:
    case OperationTypes.DATE:
    case OperationTypes.DATE_TIME:
      return {
        longValue: value
      };
    case OperationTypes.BOOLEAN:
      return {
        boolValue: value
      };
    default:
      return {
        strValue: value,
        stringValue: value
      };
  }
};
const toEngagementFilter = (operatorType, operator, getValue) => {
  const _getValue = getValue(operator),
    {
      value
    } = _getValue,
    rest = _objectWithoutPropertiesLoose(_getValue, _excluded);
  const type = operator.field.type;

  // HACK
  const isIntegrationTimelineFilterOperationTypeWithLongValueKey = [OperationTypes.LONG, OperationTypes.DATE, OperationTypes.DATE_TIME].includes(type);
  const v = isIntegrationTimelineFilterOperationTypeWithLongValueKey ? convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType']), operator.constructor === Operators.Greater) : value;
  return Object.assign({
    filterFamily: ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY,
    propertyObjectType: 'ENGAGEMENT',
    property: operator.field.name,
    operator: operatorType,
    type
  }, getEngagementValueField(type, v), rest);
};
const _getSurveyMonkeyQuestionDetails = (operatorField, operatorType) => {
  const base = {
    surveyId: getIn(['surveyId'], operatorField.metadata)
  };
  const extra = {
    colId: getIn(['colId'], operatorField.metadata),
    questionId: getIn(['questionId'], operatorField.metadata),
    questionOperator: operatorType,
    rowId: getIn(['rowId'], operatorField.metadata)
  };
  return getIn(['questionId'], operatorField.metadata) ? ImmutableMap(Object.assign({}, base, extra)).filter(identity).toJS() : base;
};
const toSurveyMonkeyFilter = (operatorType, operator, getValue) => Object.assign({
  filterFamily: ListSegClassicAssetFamilies.SURVEY_MONKEY,
  withinTimeMode: 'PAST',
  operator: OperatorTypes.SURVEY_ANSWERED,
  surveyMonkeyQuestionDetails: _getSurveyMonkeyQuestionDetails(operator.field, operatorType),
  type: operator.field.type
}, getValue(operator));
const toAdsInteractionFilter = (operatorType, operator, getValue) => {
  const [__adNetwork, adsInteractionEntity, __adsEntityListTypePrefix] = operator.field.name.split('_');
  const adNetwork = getIn(['field', 'wrappedObject', 'adNetwork'], operator) || '';
  let adsEntityListType;
  if (operator.field.name.endsWith('_id')) {
    adsEntityListType = AdsEntityListTypes.IDS;
  } else if (operator.field.name.endsWith('_name')) {
    adsEntityListType = AdsEntityListTypes.NAMES;
  } else if (operator.field.name.endsWith('_timestamp')) {
    adsEntityListType = AdsEntityListTypes.TIMESTAMP;
  } else if (operator.field.name.endsWith('_type')) {
    adsEntityListType = AdsEntityListTypes.AD_TYPE;
  }
  if (adsEntityListType === AdsEntityListTypes.TIMESTAMP) {
    const _getValue2 = getValue(operator),
      {
        value,
        highValue
      } = _getValue2,
      rest = _objectWithoutPropertiesLoose(_getValue2, _excluded2);
    const timestampAttrs = {};
    if (value) {
      if (operatorType === OperatorTypes.LESS) {
        timestampAttrs.beforeTimestamp = value;
      } else if ([OperatorTypes.BETWEEN, OperatorTypes.NOT_BETWEEN].includes(operatorType)) {
        timestampAttrs.beforeTimestamp = highValue;
        timestampAttrs.afterTimestamp = value;
      } else if (operatorType === OperatorTypes.GREATER) {
        timestampAttrs.afterTimestamp = value;
      }
    }
    return Object.assign({
      adsInteractionFilter: {
        adsEntityListType
      },
      filterFamily: ListSegClassicAssetFamilies.ADS_PROPERTY,
      operator: operatorType,
      type: operator.field.type,
      withinTimeMode: 'PAST'
    }, rest, timestampAttrs);
  }
  let convertedOperatorType = operatorType;
  if (operatorType === OperatorTypes.EQUAL && adsEntityListType === AdsEntityListTypes.NAMES) {
    // change type:string `EQUAL_ANY` (EqualAny) -> `SET_ANY` (In)
    convertedOperatorType = OperatorTypes.IN;
  }
  return {
    filterFamily: ListSegClassicAssetFamilies.ADS_PROPERTY,
    operator: convertedOperatorType,
    type: operator.field.type,
    adsInteractionFilter: {
      adNetwork: adNetwork.toUpperCase(),
      adsInteractionEntity: adsInteractionEntity.toUpperCase(),
      adsEntityListType,
      entityList: operator.value && operator.value.toJS() || []
    }
  };
};
const toIntegrationFilter = (operatorType, operator, getValue) => {
  const _getValue3 = getValue(operator),
    {
      value,
      highValue
    } = _getValue3,
    rest = _objectWithoutPropertiesLoose(_getValue3, _excluded3);
  const type = operator.field.type;
  let convertedOperatorType = operatorType;
  if (operatorType === OperatorTypes.IN) {
    convertedOperatorType = OperatorTypes.EQUAL;
  } else if (operatorType === OperatorTypes.NOT_IN) {
    convertedOperatorType = OperatorTypes.NOT_EQUAL;
  }
  const fieldName = [OperationTypes.NUMBER, OperationTypes.INTEGER, OperationTypes.DATE, OperationTypes.DATE_TIME].includes(type) ? 'longValue' : 'strValue';
  const defaultValue = fieldName === 'strValue' ? '' : 0;
  const updatedValues = {
    [fieldName]: value || defaultValue
  };

  // HACK
  const hackValues = {};
  if (isNumber(highValue)) {
    hackValues.highValue = convertSimpleDateToTimestamp(operator.highValue, operator.getIn(['field', 'timestampType']), true).toString();
  }

  // Since the _REVERSE is dropped LESS_THAN_ROLLING checks for both LESS_THAN_ROLLING and GREATER_THAN_ROLLING
  if (convertedOperatorType === OperatorTypes.LESS_THAN_ROLLING) {
    const {
      reverseWithinTimeWindow,
      withinLastTime,
      withinLastTimeUnit,
      withinTimeMode
    } = rest;
    if (reverseWithinTimeWindow) {
      updatedValues.reverseWithinTimeWindow = true;
    }
    return Object.assign({
      filterFamily: ListSegClassicAssetFamilies.INTEGRATION,
      operator: convertedOperatorType,
      type
    }, updatedValues, {
      property: operator.field.name,
      longValue: withinLastTime,
      withinLastTime: withinLastTime.toString(),
      withinLastTimeUnit,
      withinLastTimeMode: withinTimeMode,
      withinTimeMode: 'PAST'
    }, hackValues);
  }
  return Object.assign({
    filterFamily: ListSegClassicAssetFamilies.INTEGRATION,
    operator: convertedOperatorType,
    type,
    property: operator.field.name,
    withinTimeMode: 'PAST'
  }, rest, updatedValues, hackValues);
};
const toPropertyFilter = curry((getValue, operatorType, operator, filterFamily) => {
  if (filterFamily === ListSegClassicAssetFamilies.ADS_PROPERTY) {
    return toAdsInteractionFilter(operatorType, operator, getValue);
  } else if (filterFamily === ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY) {
    return toEngagementFilter(operatorType, operator, getValue);
  } else if (filterFamily === ListSegClassicAssetFamilies.SURVEY_MONKEY_QUESTION || filterFamily === ListSegClassicAssetFamilies.SURVEY_MONKEY) {
    return toSurveyMonkeyFilter(operatorType, operator, getValue);
  } else if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
    return toIntegrationFilter(operatorType, operator, getValue);
  }
  const sharedFields = Object.assign({
    filterFamily,
    operator: operatorType,
    property: operator.field.name,
    type: operator.field.type,
    withinTimeMode: 'PAST'
  }, getValue(operator));
  return filterFamily === ListSegClassicAssetFamilies.COMPANY_PROPERTY_VALUE || filterFamily === ListSegClassicAssetFamilies.COMPANY_PROPERTY ? Object.assign({}, sharedFields, {
    propertyObjectType: 'COMPANY'
  }) : sharedFields;
});
const toOtherFilter = curry((getValue, operatorType, operator, filterFamily) => Object.assign({
  filterFamily,
  operator: operatorType,
  withinTimeMode: 'PAST'
}, getValue(operator)));
const convertPrivacyConsentFilter = operator => {
  const value = get('value', operator);
  return value ? {
    filterFamily: PRIVACY_CONSENT,
    value
  } : {
    filterFamily: PRIVACY_CONSENT
  };
};
const getEmailCampaignRefinementFields = operator => {
  if (operator.constructor === undefined) {
    return {};
  }
  const sharedFields = {
    absoluteEventDate: convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType']), operator.constructor === Operators.LessOrEqual),
    relativeDateType: 'ABSOLUTE'
  };
  switch (operator.constructor) {
    case Operators.GreaterOrEqual:
      return Object.assign({}, sharedFields, {
        timeOperator: 'AFTER'
      });
    case Operators.InRange:
      return Object.assign({}, sharedFields, {
        highAbsoluteEventDate: convertSimpleDateToTimestamp(operator.highValue, operator.getIn(['field', 'timestampType']), true),
        timeOperator: 'BETWEEN'
      });
    case Operators.LessOrEqual:
      return Object.assign({}, sharedFields, {
        timeOperator: 'BEFORE'
      });
    default:
      return {};
  }
};
const getRefinementFields = (filterFamily, operator) => {
  if (operator.constructor === undefined) {
    return {};
  }
  switch (operator.constructor) {
    case Operators.GreaterOrEqual:
      return {
        afterTimestamp: convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType']))
      };
    case Operators.LessOrEqual:
      return {
        beforeTimestamp: convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType']), true)
      };
    case Operators.GreaterThanRolling:
    case Operators.LessThanRolling:
      // eslint-disable-next-line no-use-before-define
      return rollingConverter(operator);
    case Operators.InRange:
      return {
        afterTimestamp: convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType'])),
        beforeTimestamp: convertSimpleDateToTimestamp(operator.highValue, operator.getIn(['field', 'timestampType']), true)
      };
    case Operators.Greater:
      return {
        minOccurrences: operator.value
      };
    case Operators.Less:
      return {
        maxOccurrences: operator.value
      };
    case Operators.Equal:
      return {
        maxOccurrences: operator.value,
        minOccurrences: operator.value
      };
    case Operators.Any:
    default:
      return {};
  }
};
const toRefinedFilter = curry((getValue, operatorType, operator, filterFamily) => {
  const filter = toOtherFilter(getValue, operatorType, operator, filterFamily);
  if (operator.refinement) {
    return Object.assign({}, filter, getRefinementFields(filterFamily, operator.refinement));
  }
  return filter;
});
const _toArrayString = iterableValue => iterableValue && typeof iterableValue.join === 'function' ? iterableValue.join(';') : iterableValue;
const _toFormBackendValue = value => {
  const specialValues = {
    [__ANY_FORM]: '',
    [__ANY_PAGE]: ''
  };
  return Object.prototype.hasOwnProperty.call(specialValues, value) ? specialValues[value] : value;
};
const addHistoryField = curry((converter, operator) => Object.assign({
  checkPastVersions: true
}, converter(operator)));
const compareConverter = operator => operator && operator.has('value') ? {
  compareProperty: operator.value
} : {};
const rollingConverter = operator => {
  if (!operator || !operator.has('timeUnit') || !operator.has('value') || !operator.has('direction')) {
    return {};
  }
  return {
    reverseWithinTimeWindow: operator.constructor === Operators.GreaterThanRolling,
    withinLastDays: operator.timeUnit === 'days' ? operator.value : operator.value * 7,
    withinLastTime: operator.value,
    withinTimeMode: operator.direction === 'backward' ? 'PAST' : 'FUTURE',
    withinLastTimeUnit: operator.timeUnit === 'days' ? 'DAYS' : 'WEEKS'
  };
};
const iterableConverter = operator => operator && operator.has('value') ? {
  value: _toArrayString(operator.value)
} : {};
const valueConverter = operator => {
  const isGreaterThanOperation = operator.constructor === Operators.Greater;
  const listSegOperationType = operator.field.type || OperationTypes.STRING;
  const isDateOperation = [OperationTypes.DATE_TIME, OperationTypes.DATE].includes(listSegOperationType);
  if (isDateOperation && operator && operator.value) {
    return {
      value: convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType']), isGreaterThanOperation)
    };
  } else if (operator.field.type === OperationTypes.STRING) {
    return iterableConverter(operator);
  } else if (operator && operator.has('value')) {
    return {
      value: operator.value
    };
  }
  return {};
};
const rangedConverter = operator => operator && operator.has('value') && operator.has('highValue') ? {
  value: convertSimpleDateToTimestamp(operator.value, operator.getIn(['field', 'timestampType'])),
  highValue: convertSimpleDateToTimestamp(operator.highValue, operator.getIn(['field', 'timestampType']), operator.constructor === Operators.InRange || operator.constructor === Operators.NotInRange)
} : {};
const ctaValueConverter = operator => {
  const result = {};
  if (operator.value === __ANY_CTA) {
    result.operator = `${OperatorsToListType.get(operator.constructor)}_PLACEMENT`;
    const value = operator.field.name;
    result.value = value;
    result.placement = value;
  } else {
    result.cta = operator.value;
    result.value = operator.value;
  }
  return result;
};
const importValueConverter = operator => operator && operator.hasIn(['field', 'name']) ? {
  importId: parseInt(operator.field.name, 10)
} : {};
const listValueConverter = operator => operator && operator.hasIn(['field', 'name']) ? {
  dynamicList: get('dynamicList', operator.field.metadata),
  list: parseInt(operator.field.name, 10)
} : {};
const emailCampaignConverter = (operator, operatorType) => {
  let filterLines;
  const sharedFields = {
    countryCode: [],
    // required
    eventTypes: [] // This looks like it's never used in Cerebro but it's in all the filters, so I'm initializing it for
  };
  const refinementFields = operator.refinement ? getEmailCampaignRefinementFields(operator.refinement) : {};
  if (operatorType === OperatorTypes.EMAIL_OPENED_NOT_CLICKED) {
    filterLines = [Object.assign({
      eventType: OperatorTypes.EMAIL_OPENED
    }, refinementFields, sharedFields), Object.assign({
      eventType: OperatorTypes.EMAIL_CLICKED,
      negated: true
    }, sharedFields)];
  } else if (operatorType === OperatorTypes.EMAIL_OPENED_NOT_REPLIED) {
    filterLines = [Object.assign({
      eventType: OperatorTypes.EMAIL_OPENED
    }, refinementFields, sharedFields), Object.assign({
      eventType: OperatorTypes.EMAIL_REPLIED,
      negated: true
    }, sharedFields)];
  } else if (operatorType === OperatorTypes.EMAIL_RECEIVED_NOT_OPENED) {
    filterLines = [Object.assign({
      eventType: OperatorTypes.EMAIL_RECEIVED
    }, refinementFields, sharedFields), Object.assign({
      eventType: OperatorTypes.EMAIL_OPENED,
      negated: true
    }, sharedFields)];
  } else if (operatorType === OperatorTypes.EMAIL_SENT_NOT_CLICKED) {
    filterLines = [Object.assign({
      eventType: OperatorTypes.EMAIL_SENT
    }, refinementFields, sharedFields), Object.assign({
      eventType: OperatorTypes.EMAIL_CLICKED,
      negated: true
    }, sharedFields)];
  } else if (operatorType === OperatorTypes.EMAIL_SENT_NOT_RECEIVED) {
    filterLines = [Object.assign({
      eventType: OperatorTypes.EMAIL_SENT
    }, refinementFields, sharedFields), Object.assign({
      eventType: OperatorTypes.EMAIL_RECEIVED,
      negated: true
    }, sharedFields)];
  } else if (operatorType === OperatorTypes.EMAIL_CLICKED) {
    const fields = Object.assign({
      eventType: operatorType
    }, refinementFields, sharedFields);
    if (operator.value && operator.value !== __ANY_LINK) {
      fields.clickUrlSubstring = operator.value;
    }
    filterLines = [Object.assign({}, fields, refinementFields, sharedFields)];
  } else {
    filterLines = [Object.assign({
      eventType: operatorType
    }, refinementFields, sharedFields)];
  }
  return {
    emailEventFilter: {
      appId: get('appId', operator.field.metadata),
      emailEventEventFilterLines: filterLines,
      emailId: parseInt(operator.field.name, 10),
      level: get('level', operator.field.metadata)
    }
  };
};
const toEmailCampaignFilter = curry((operatorType, operator) => {
  const value = emailCampaignConverter(operator, operatorType);
  return Object.assign({
    filterFamily: ListSegClassicAssetFamilies.EMAIL_CAMPAIGN,
    operator: OperatorTypes.EMAIL_EVENT,
    withinTimeMode: 'PAST'
  }, value);
});
const toEmailSubscriptionFilter = curry((operatorType, operator) => {
  const value = operator && operator.has('value') ? operator.value.map(val => parseInt(val, 10)).toArray() : [];
  return {
    filterFamily: ListSegClassicAssetFamilies.EMAIL_SUBSCRIPTION,
    subscriptionsFilter: {
      optStatuses: [operatorType],
      subscriptionIds: value
    }
  };
});
const eventValueConverter = operator => operator && operator.hasIn(['field', 'name']) ? {
  value: operator.field.name
} : {};
const formValueConverter = operator => operator && operator.hasIn(['field', 'name']) ? {
  form: _toFormBackendValue(operator.field.name),
  page: _toFormBackendValue(getIn(['value'], operator))
} : {};
const surveyMonkeyValueConverter = operator => operator && operator.hasIn(['field', 'name']) ? {
  surveyMonkeyQuestionDetails: {
    surveyId: operator.field.name
  }
} : {};
const webinarValueConverter = operator => {
  if (operator && operator.hasIn(['field', 'name'])) {
    const name = operator.field.name;
    const value = name === __ANY_WEBINAR ? '' : name;
    return {
      value
    };
  }
  return {};
};
const workflowValueConverter = operator => operator && operator.hasIn(['field', 'name']) ? {
  workflowId: parseInt(operator.field.name, 10)
} : {};
const invalidOperator = operator => {
  invariant(false, 'cannot convert filter operator "%s" to ListSegClassic filter', operator.name);
};
const convertToListSegClassic = protocol({
  name: 'convertToObjectSeg',
  args: [protocol.TYPE, isString],
  fallback: invalidOperator
});
convertToListSegClassic.implement(Operators.After, toPropertyFilter(compareConverter, OperatorTypes.GREATER));
convertToListSegClassic.implement(Operators.Before, toPropertyFilter(compareConverter, OperatorTypes.LESS));
convertToListSegClassic.implement(Operators.Contain, toPropertyFilter(valueConverter, OperatorTypes.CONTAIN));
convertToListSegClassic.implement(Operators.ContainAll, toPropertyFilter(iterableConverter, OperatorTypes.CONTAIN_ALL));
convertToListSegClassic.implement(Operators.ContainAllTeams, toPropertyFilter(iterableConverter, OperatorTypes.CONTAIN_ALL));
convertToListSegClassic.implement(Operators.ContainAny, toPropertyFilter(iterableConverter, OperatorTypes.CONTAIN));
convertToListSegClassic.implement(Operators.EndsWithAny, toPropertyFilter(valueConverter, OperatorTypes.ENDS_WITH));
convertToListSegClassic.implement(Operators.Equal, toPropertyFilter(valueConverter, OperatorTypes.EQUAL));
convertToListSegClassic.implement(Operators.EqualAll, toPropertyFilter(iterableConverter, OperatorTypes.EQUAL_ALL));
convertToListSegClassic.implement(Operators.EqualAny, toPropertyFilter(iterableConverter, OperatorTypes.EQUAL));
convertToListSegClassic.implement(Operators.EverContained, toPropertyFilter(addHistoryField(valueConverter), OperatorTypes.CONTAIN));
convertToListSegClassic.implement(Operators.EverContainedAll, toPropertyFilter(addHistoryField(iterableConverter), OperatorTypes.EQUAL_ALL));
convertToListSegClassic.implement(Operators.EverContainedAny, toPropertyFilter(addHistoryField(iterableConverter), OperatorTypes.CONTAIN));
convertToListSegClassic.implement(Operators.EverEqual, toPropertyFilter(addHistoryField(valueConverter), OperatorTypes.EQUAL));
convertToListSegClassic.implement(Operators.EverEqualAny, toPropertyFilter(addHistoryField(valueConverter), OperatorTypes.EQUAL));
convertToListSegClassic.implement(Operators.EverIn, toPropertyFilter(addHistoryField(iterableConverter), OperatorTypes.IN));
convertToListSegClassic.implement(Operators.Greater, toPropertyFilter(valueConverter, OperatorTypes.GREATER));
convertToListSegClassic.implement(Operators.GreaterOrEqual, toPropertyFilter(valueConverter, OperatorTypes.GREATER_OR_EQUAL));
convertToListSegClassic.implement(Operators.GreaterThanRolling, toPropertyFilter(rollingConverter, OperatorTypes.LESS_THAN_ROLLING));
convertToListSegClassic.implement(Operators.In, toPropertyFilter(iterableConverter, OperatorTypes.IN));
convertToListSegClassic.implement(Operators.InRange, toPropertyFilter(rangedConverter, OperatorTypes.BETWEEN));
convertToListSegClassic.implement(Operators.Known, toPropertyFilter(valueConverter, OperatorTypes.KNOWN));
convertToListSegClassic.implement(Operators.Less, toPropertyFilter(valueConverter, OperatorTypes.LESS));
convertToListSegClassic.implement(Operators.LessOrEqual, toPropertyFilter(valueConverter, OperatorTypes.LESS_OR_EQUAL));
convertToListSegClassic.implement(Operators.LessThanRolling, toPropertyFilter(rollingConverter, OperatorTypes.LESS_THAN_ROLLING));
convertToListSegClassic.implement(Operators.NotContain, toPropertyFilter(valueConverter, OperatorTypes.NOT_CONTAIN));
convertToListSegClassic.implement(Operators.NotContainAll, toPropertyFilter(iterableConverter, OperatorTypes.NOT_CONTAIN_ALL));
convertToListSegClassic.implement(Operators.NotContainAny, toPropertyFilter(iterableConverter, OperatorTypes.NOT_CONTAIN));
convertToListSegClassic.implement(Operators.NotEqual, toPropertyFilter(valueConverter, OperatorTypes.NOT_EQUAL));
convertToListSegClassic.implement(Operators.NotEqualAll, toPropertyFilter(iterableConverter, OperatorTypes.NOT_EQUAL_ALL));
convertToListSegClassic.implement(Operators.NotEqualAny, toPropertyFilter(iterableConverter, OperatorTypes.NOT_EQUAL));
convertToListSegClassic.implement(Operators.NeverContainedAll, toPropertyFilter(addHistoryField(iterableConverter), OperatorTypes.NOT_EQUAL_ALL));
convertToListSegClassic.implement(Operators.NeverEqual, toPropertyFilter(addHistoryField(valueConverter), OperatorTypes.NOT_EQUAL));
convertToListSegClassic.implement(Operators.NeverEqualAny, toPropertyFilter(addHistoryField(valueConverter), OperatorTypes.NOT_EQUAL));
convertToListSegClassic.implement(Operators.NeverIn, toPropertyFilter(addHistoryField(iterableConverter), OperatorTypes.NOT_IN));
convertToListSegClassic.implement(Operators.NotIn, toPropertyFilter(iterableConverter, OperatorTypes.NOT_IN));
convertToListSegClassic.implement(Operators.NotInRange, toPropertyFilter(rangedConverter, OperatorTypes.NOT_BETWEEN));
convertToListSegClassic.implement(Operators.NotKnown, toPropertyFilter(valueConverter, OperatorTypes.NOT_KNOWN));
convertToListSegClassic.implement(Operators.StartsWithAny, toPropertyFilter(valueConverter, OperatorTypes.STARTS_WITH));
// PRIVACY CONSENT (Appears as an contact property field)
convertToListSegClassic.implement(Operators.PrivacyConsentCompleted, toRefinedFilter(convertPrivacyConsentFilter, OperatorTypes.HAS_PRIVACY_CONSENT));
convertToListSegClassic.implement(Operators.PrivacyConsentNotCompleted, toRefinedFilter(convertPrivacyConsentFilter, OperatorTypes.HAS_NOT_PRIVACY_CONSENT));

// CTA
convertToListSegClassic.implement(Operators.CtaHasClicked, toRefinedFilter(ctaValueConverter, OperatorTypes.CTA_HAS_CLICKED));
convertToListSegClassic.implement(Operators.CtaHasNotClicked, toRefinedFilter(ctaValueConverter, OperatorTypes.CTA_NOT_HAS_CLICKED));
convertToListSegClassic.implement(Operators.CtaHasNotSeen, toRefinedFilter(ctaValueConverter, OperatorTypes.CTA_NOT_HAS_SEEN));
convertToListSegClassic.implement(Operators.CtaHasSeen, toRefinedFilter(ctaValueConverter, OperatorTypes.CTA_HAS_SEEN));

// EMAIL CAMPAIGN
convertToListSegClassic.implement(Operators.EmailBounced, toEmailCampaignFilter(OperatorTypes.EMAIL_BOUNCED));
convertToListSegClassic.implement(Operators.EmailLinkClicked, toEmailCampaignFilter(OperatorTypes.EMAIL_CLICKED));
convertToListSegClassic.implement(Operators.EmailMarked, toEmailCampaignFilter(OperatorTypes.EMAIL_MARKED));
convertToListSegClassic.implement(Operators.EmailOpened, toEmailCampaignFilter(OperatorTypes.EMAIL_OPENED));
convertToListSegClassic.implement(Operators.EmailOpenedButLinkNotClicked, toEmailCampaignFilter(OperatorTypes.EMAIL_OPENED_NOT_CLICKED));
convertToListSegClassic.implement(Operators.EmailOpenedButNotReplied, toEmailCampaignFilter(OperatorTypes.EMAIL_OPENED_NOT_REPLIED));
convertToListSegClassic.implement(Operators.EmailReceived, toEmailCampaignFilter(OperatorTypes.EMAIL_RECEIVED));
convertToListSegClassic.implement(Operators.EmailReceivedButNotOpened, toEmailCampaignFilter(OperatorTypes.EMAIL_RECEIVED_NOT_OPENED));
convertToListSegClassic.implement(Operators.EmailReplied, toEmailCampaignFilter(OperatorTypes.EMAIL_REPLIED));
convertToListSegClassic.implement(Operators.EmailSent, toEmailCampaignFilter(OperatorTypes.EMAIL_SENT));
convertToListSegClassic.implement(Operators.EmailSentButLinkNotClicked, toEmailCampaignFilter(OperatorTypes.EMAIL_SENT_NOT_CLICKED));
convertToListSegClassic.implement(Operators.EmailSentButNotReceived, toEmailCampaignFilter(OperatorTypes.EMAIL_SENT_NOT_RECEIVED));
convertToListSegClassic.implement(Operators.EmailUnsubscribed, toEmailCampaignFilter(OperatorTypes.EMAIL_UNSUBSCRIBED));

// EMAIL SUBSCRIPTION
convertToListSegClassic.implement(Operators.EmailSubscriptionNotOpted, toEmailSubscriptionFilter(OperatorTypes.HAS_NOT_OPTED));
convertToListSegClassic.implement(Operators.EmailSubscriptionOptIn, toEmailSubscriptionFilter(OperatorTypes.HAS_OPTED_IN));
convertToListSegClassic.implement(Operators.EmailSubscriptionOptOut, toEmailSubscriptionFilter(OperatorTypes.HAS_OPTED_OUT));

// EVENT
convertToListSegClassic.implement(Operators.EventCompleted, toRefinedFilter(eventValueConverter, OperatorTypes.EVENT_HAS));
convertToListSegClassic.implement(Operators.EventNotCompleted, toRefinedFilter(eventValueConverter, OperatorTypes.EVENT_NOT_HAS));

// FORM
convertToListSegClassic.implement(Operators.FormFilledOut, toRefinedFilter(formValueConverter, OperatorTypes.FORM_FILLED_OUT));
convertToListSegClassic.implement(Operators.FormNotFilledOut, toRefinedFilter(formValueConverter, OperatorTypes.FORM_NOT_FILLED_OUT));

// IMPORT
convertToListSegClassic.implement(Operators.InImport, toOtherFilter(importValueConverter, OperatorTypes.IN_IMPORT));
convertToListSegClassic.implement(Operators.NotInImport, toOtherFilter(importValueConverter, OperatorTypes.NOT_IN_IMPORT));

// LIST
convertToListSegClassic.implement(Operators.ListIsMember, toOtherFilter(listValueConverter, OperatorTypes.LIST_IN));
convertToListSegClassic.implement(Operators.ListIsNotMember, toOtherFilter(listValueConverter, OperatorTypes.LIST_NOT_IN));

// PAGEVIEW
convertToListSegClassic.implement(Operators.PageViewContain, toRefinedFilter(valueConverter, OperatorTypes.PAGEVIEW_CONTAINS));
convertToListSegClassic.implement(Operators.PageViewEqual, toRefinedFilter(valueConverter, OperatorTypes.PAGEVIEW_EQUAL));
convertToListSegClassic.implement(Operators.PageViewMatchRegex, toRefinedFilter(valueConverter, OperatorTypes.PAGEVIEW_MATCHES));
convertToListSegClassic.implement(Operators.PageViewNotContain, toRefinedFilter(valueConverter, OperatorTypes.PAGEVIEW_NOT_CONTAINS));
convertToListSegClassic.implement(Operators.PageViewNotEqual, toRefinedFilter(valueConverter, OperatorTypes.PAGEVIEW_NOT_EQUAL));
convertToListSegClassic.implement(Operators.PageViewNotMatchRegex, toRefinedFilter(valueConverter, OperatorTypes.PAGEVIEW_NOT_MATCHES));

// SURVEY_MONKEY
convertToListSegClassic.implement(Operators.SurveyMonkeyHasResponded, toOtherFilter(surveyMonkeyValueConverter, OperatorTypes.SURVEY_RESPONDED));
convertToListSegClassic.implement(Operators.SurveyMonkeyNotHasResponded, toOtherFilter(surveyMonkeyValueConverter, OperatorTypes.SURVEY_NOT_RESPONDED));

// WEBINAR
convertToListSegClassic.implement(Operators.WebinarHasAttended, toOtherFilter(webinarValueConverter, OperatorTypes.WEBINAR_ATTENDED));
convertToListSegClassic.implement(Operators.WebinarNotHasAttended, toOtherFilter(webinarValueConverter, OperatorTypes.WEBINAR_NOT_ATTENDED));
convertToListSegClassic.implement(Operators.WebinarNotHasRegistered, toOtherFilter(webinarValueConverter, OperatorTypes.WEBINAR_NOT_REGISTERED));
convertToListSegClassic.implement(Operators.WebinarHasRegistered, toOtherFilter(webinarValueConverter, OperatorTypes.WEBINAR_REGISTERED));

// WORKFLOW
convertToListSegClassic.implement(Operators.WorkflowActive, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_ACTIVE));
convertToListSegClassic.implement(Operators.WorkflowCompleted, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_COMPLETED));
convertToListSegClassic.implement(Operators.WorkflowEnrolled, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_ENROLLED));
convertToListSegClassic.implement(Operators.WorkflowMetGoal, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_MET_GOAL));
convertToListSegClassic.implement(Operators.WorkflowNotActive, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_NOT_ACTIVE));
convertToListSegClassic.implement(Operators.WorkflowNotCompleted, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_NOT_COMPLETED));
convertToListSegClassic.implement(Operators.WorkflowNotEnrolled, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_NOT_ENROLLED));
convertToListSegClassic.implement(Operators.WorkflowNotMetGoal, toOtherFilter(workflowValueConverter, OperatorTypes.WORKFLOW_NOT_MET_GOAL));
const convertDSAssetFamilyToListSegClassicFamily = assetFamily => {
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
    return assetFamily;
  }
  return DSAssetFamilyToListSegClassicType.get(assetFamily);
};
const getFilterFamily = (operator, andGroup) => {
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, andGroup.filterFamily)) {
    return andGroup.filterFamily;
  }
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, operator.filterFamily)) {
    return operator.filterFamily;
  }
  const assetFamily = operator.filterFamily ? operator.filterFamily : andGroup.filterFamily;
  const filterFamily = convertDSAssetFamilyToListSegClassicFamily(assetFamily);
  if (filterFamily === ListSegClassicAssetFamilies.LINE_ITEM_PROPERTY) {
    return ListSegClassicAssetFamilies.DEAL_PROPERTY;
  } else if (filterFamily === ListSegClassicAssetFamilies.PRODUCT_PROPERTY) {
    return ListSegClassicAssetFamilies.DEAL_PROPERTY;
  }
  return filterFamily;
};
const getPropertyObjectType = operator => {
  const filterFamily = convertDSAssetFamilyToListSegClassicFamily(operator.filterFamily);
  if (filterFamily === ListSegClassicAssetFamilies.LINE_ITEM_PROPERTY) {
    return 'LINE_ITEM';
  } else if (filterFamily === ListSegClassicAssetFamilies.PRODUCT_PROPERTY) {
    return 'PRODUCT';
  } else {
    return 'DEAL';
  }
};
export function toListSegClassic(filterQuery, constraint) {
  const convertAndGroup = andGroup => andGroup.conditions.valueSeq().reduce((acc, operator) => {
    const filterFamily = getFilterFamily(operator, andGroup);
    if (operator.name === 'And') {
      const assetFamily = testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily) ? ListSegClassicAssetFamilies.INTEGRATION : filterFamily;
      const branchKey = BranchKeyByAssetFamily[assetFamily];
      if (!branchKey && operator.name === 'And') {
        return acc.concat(convertAndGroup(operator));
      }
      const toFilterLine = filter => {
        if (filterFamily === ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY) {
          return filter;
        } else if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
          return {
            filter
          };
        } else {
          return {
            dealSelector: 'ALL',
            filter: Object.assign({}, filter, {
              propertyObjectType: getPropertyObjectType(operator)
            })
          };
        }
      };
      const filterLinesKey = FilterLinesKeyByAssetFamily[assetFamily];
      const filterLines = convertAndGroup(operator).map(toFilterLine);
      const listSegQuery = {
        filterFamily: assetFamily,
        [branchKey]: {
          [filterLinesKey]: filterLines
        }
      };
      if (filterFamily === ListSegClassicAssetFamilies.ENGAGEMENT_PROPERTY) {
        listSegQuery.propertyObjectType = 'ENGAGEMENT';
      } else if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
        listSegQuery[branchKey].eventTypeId = parseInt(filterFamily.split('-')[1], 10);
        listSegQuery.operator = OperatorTypes.INTEGRATION_OPERATOR;
        listSegQuery.withinTimeMode = listSegQuery.withinTimeMode || 'PAST';
      } else {
        listSegQuery.withinTimeMode = listSegQuery.withinTimeMode || 'PAST';
      }
      acc.push(listSegQuery);
      return acc;
    }
    acc.push(convertToListSegClassic(operator, filterFamily));
    return acc;
  }, []).filter(identity);
  return filterQuery.conditions.valueSeq().map(Constraint.applyToGroup(constraint)).map(convertAndGroup).toArray();
}